module.exports = __webpack_public_path__ + "static2023-4-17/img/2020_dialog.d4a61604.png";